'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/*eslint-disable sort-keys */
var savedSearchSortOrders = {
    LAST_SENT_ASCENDING: 'LAST_SENT_ASCENDING',
    LAST_SENT_DESCENDING: 'LAST_SENT_DESCENDING',
    SEARCH_TERM_ASCENDING: 'SEARCH_TERM_ASCENDING',
    SEARCH_TERM_DESCENDING: 'SEARCH_TERM_DESCENDING'
};

exports.default = savedSearchSortOrders;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/enums/savedSearchSortOrders.js
// module id = NmEf
// module chunks = 46